import { getAuth } from 'firebase/auth';
import { getFirestore, addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { app } from '../firebase';

export const logAdminActivity = async ({ action, details, meta = {} }) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    const db = getFirestore(app);
    const adminName = user.displayName || user.email || 'Admin';
    await addDoc(collection(db, 'AdminActivity'), {
      adminId: user.uid,
      adminName,
      action: action || 'Activity',
      details: details || '',
      createdAt: serverTimestamp(),
      ...meta
    });
  } catch (error) {
    console.error('Failed to log activity:', error);
  }
};
